import { Container } from "pixi.js";
import { GRID_UNIT } from "@/lib/game/constants";
import { PART_BY_ID } from "@/lib/game/parts";
import { createPartNode, applyPartPlacementTransform } from "@/game/builder/drawPart";
import {
  categoryZIndex,
  DEFAULT_ROCKET_PLACEMENTS,
  hasCustomRocket,
  isRocketFlyable,
  type PlacedPart,
  rocketPlacementsForDisplay,
} from "@/lib/game/placements";

export {
  DEFAULT_ROCKET_PLACEMENTS,
  hasCustomRocket,
  isRocketFlyable,
  rocketPlacementsForDisplay,
};
export type { PlacedPart };

export function buildRocketContainer(placements: PlacedPart[]): Container {
  const rocket = new Container();
  rocket.sortableChildren = true;

  const sorted = [...placements].sort((a, b) => {
    const pa = PART_BY_ID[a.partId];
    const pb = PART_BY_ID[b.partId];
    return (pa ? categoryZIndex(pa) : 0) - (pb ? categoryZIndex(pb) : 0);
  });

  for (const placed of sorted) {
    const part = PART_BY_ID[placed.partId];
    if (!part) continue;

    const wrap = createPartNode(part);
    wrap.position.set(placed.x * GRID_UNIT, placed.y * GRID_UNIT);
    wrap.zIndex = categoryZIndex(part);
    applyPartPlacementTransform(wrap, part, placed);
    rocket.addChild(wrap);
  }

  rocket.sortChildren();
  return rocket;
}
